import { User } from '../types';
import { showToRoles } from './show-to-roles';

export const getDefaultRouter = (onlyLastPath = false) => {
  const userData = localStorage.getItem('user');
  const user: User = JSON.parse(userData || '{}');
  let path = '/dashboard/containers';

  if (
    showToRoles(
      [
        'SUPER_ADMIN',
        'YARD_COMPANY_ADMIN',
        'YARD_COMPANY_EMPLOYEE',
        'YARD_COMPANY_VIEWER',
        'YARD_MANAGER',
        'YARD_DISPATCHER',
        'VENDOR',
      ],
      user,
    )
  ) {
    path = '/dashboard/overview';
  }

  if (showToRoles(['TRADER'], user)) {
    path = '/dashboard/marketplace';
  }

  return onlyLastPath ? path.split('/').pop() || '' : path;
};
